// src/pages/AdminAuditLog.tsx — paginated, filterable audit log viewer.
import { useState } from "react";
import { useAdminAuditLog } from "@/lib/queries";
import { Card, PageHeader, Spinner, EmptyState, ErrorBanner } from "@/components/ui";

export function AdminAuditLog() {
  const [actionFilter, setActionFilter] = useState("");
  const [applied, setApplied] = useState("");
  const { data, isLoading, error } = useAdminAuditLog(applied || undefined);

  const items = data?.items ?? [];

  return (
    <div className="space-y-6">
      <PageHeader title="Audit Log" subtitle="Append-only record of sensitive actions." />

      <form
        className="flex flex-wrap gap-3"
        onSubmit={(e) => {
          e.preventDefault();
          setApplied(actionFilter.trim());
        }}
      >
        <input
          aria-label="filter action"
          placeholder="Filter by action (e.g. admin.override)"
          value={actionFilter}
          onChange={(e) => setActionFilter(e.target.value)}
          className="flex-1 rounded-lg border border-white/15 bg-transparent px-3 py-2 text-sm text-ls-fg outline-none focus:border-ls-accent"
        />
        <button
          type="submit"
          className="rounded-lg border border-white/15 px-4 py-2 text-sm text-ls-fg hover:bg-white/5"
        >
          Apply
        </button>
      </form>

      {error ? (
        <ErrorBanner message={(error as Error).message} />
      ) : isLoading ? (
        <Spinner />
      ) : items.length === 0 ? (
        <EmptyState title="No audit entries match" />
      ) : (
        <Card>
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs text-ls-muted">
                <th className="py-1">When</th>
                <th className="py-1">Actor</th>
                <th className="py-1">Role</th>
                <th className="py-1">Action</th>
                <th className="py-1">Target</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a) => (
                <tr key={a.id} className="border-t border-white/5 text-ls-fg">
                  <td className="py-1.5 text-ls-muted">
                    {new Date(a.createdAt).toLocaleString()}
                  </td>
                  <td className="py-1.5">{a.actorId}</td>
                  <td className="py-1.5 text-ls-muted">{a.actorRole}</td>
                  <td className="py-1.5 font-mono text-xs">{a.action}</td>
                  <td className="py-1.5 text-ls-muted">{a.targetId ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {data?.nextBefore != null ? (
            <p className="mt-3 text-xs text-ls-muted">
              More entries exist (keyset before id {data.nextBefore}). Pagination UI is a
              follow-up.
            </p>
          ) : null}
        </Card>
      )}
    </div>
  );
}
